(function() {
  'use strict';

  angular.module('eclipseApp.linkAccount').factory('linkAccountService', linkAccountService);

  linkAccountService.$inject = [
    '$q',
    '$rootScope',
    '$modal',
    '$translate',
    'httpService',
    'userService',
    'dtmService',
    'dtmServiceConstants',
    'downgradedUserService'
  ];

  /* @ngInject */
  function linkAccountService(
    $q,
    $rootScope,
    $modal,
    $translate,
    httpService,
    userService,
    dtmService,
    dtmServiceConstants,
    downgradedUserService
  ) {
    var service = {};
    var dtmRule = dtmServiceConstants.dtmRules.dtmLinkAccount;

    service.linkAccountOwner = function(uuid, userID, accountNumber, postalCode) {
      var payload = {
        uuid: uuid,
        userID: userID,
        accountNumber2: accountNumber,
        firstName: '',
        lastName: '',
        companyName: null,
        dateOfBirth: '',
        postalCode: postalCode,
        billingType: 'online',
        accountNumber3: null
      };
      return httpService
        .send('linkAccountOwner', payload)
        .then(function(result) {
          if (result.data.error || result.data.status === 'Failed') {
            var errorMessage = '';
            if (result.data && (result.data.error === '50000' || result.data.error === '70012')) {
              errorMessage = 'global.error.postBack.50000';
            } else if (result.data && result.data.error === '70015') {
              errorMessage = 'global.error.postBack.account.70015';
            } else if (result.data && result.data.error === '70016') {
              errorMessage = 'global.error.postBack.account.70016';
            } else if (result.data && result.data.error === '70014') {
              errorMessage = 'global.error.inline.info.nonExistent';
            }

            $translate(errorMessage).then(function(translatedValue) {
              var serverSideError = 'SS|' + translatedValue || dtmRule.defaultServerError;
              dtmService.setVar(dtmRule.eVar, serverSideError);
              dtmService.direct(dtmRule.errorRule);
            });
          } else {
            dtmService.direct(dtmRule.completeRule);
          }
          return result;
        })
        .catch(function(err) {
          var serverSideError = 'SS|' + dtmRule.defaultServerError;
          dtmService.setVar(dtmRule.eVar, serverSideError);
          dtmService.direct(dtmRule.errorRule);
          return $q.reject(err);
        });
    };

    service.linkAccountPrepaidSubscriber = function(uuid, phoneNo, reCaptcha) {
      var payload = {
        uuid: uuid,
        ctn: phoneNo,
        reCaptcha: reCaptcha
      };
      return httpService
        .send('linkAccountSubscriber', payload)
        .then(function(result) {
          if (result.data.error || result.data.status === 'Failed') {
            var errorMessage = '';
            if (result.data && (result.data.error === '50000' || result.data.error === '70012')) {
              errorMessage = 'global.error.postBack.50000';
            } else if (result.data && result.data.error === '50018') {
              errorMessage = 'global.error.postBack.account.50018';
            } else if (result.data && result.data.error === '70015') {
              errorMessage = 'global.error.postBack.account.70015';
            } else if (result.data && result.data.error === '70016') {
              errorMessage = 'global.error.postBack.account.70016';
            } else if (result.data && result.data.error === '70014') {
              errorMessage = 'global.error.inline.info.nonExistent';
            }

            $translate(errorMessage).then(function(translatedValue) {
              var serverSideError = 'SS|' + translatedValue || dtmRule.defaultServerError;
              dtmService.setVar(dtmRule.eVar, serverSideError);
              dtmService.direct(dtmRule.errorRule);
            });
          }
          return result;
        })
        .catch(function(err) {
          var serverSideError = 'SS|' + dtmRule.defaultServerError;
          dtmService.setVar(dtmRule.eVar, serverSideError);
          dtmService.direct(dtmRule.errorRule);
          return $q.reject(err);
        });
    };

    service.openAlreadyConnectedModal = function(emailAddress) {
      $modal.open({
        templateUrl: 'modules/link-account/already-connected/already-connected.view.html',
        controller: 'alreadyConnectedController',
        controllerAs: 'ctrl',
        windowClass: 'verify-mobile-number-modal already-connected-modal',
        size: 'md',
        backdrop: false,
        resolve: {
          modalConfig: function() {
            return {
              emailAddress: emailAddress
            };
          }
        }
      });
    };

    service.validateLinkAccountPrepaidSubscriber = function(uuid, phoneNo, verificationCode, emailAddress) {
      var payload = {
        uuid: uuid,
        ctn: phoneNo,
        code: verificationCode,
        emailAddress: emailAddress
      };
      return httpService
        .send('validateLinkAccountSubscriber', payload)
        .then(function(result) {
          if (result.data.error || result.data.status === 'Failed') {
            var errorMessage = '';
            if (result.data && (result.data.error === '50000' || result.data.error === '70012')) {
              errorMessage = 'global.error.postBack.50000';
            } else if (result.data && result.data.error === '70013') {
              errorMessage = 'global.error.inline.account.linkFailed';
            } else if (result.data && result.data.error === '70016') {
              errorMessage = 'global.error.postBack.account.70016';
            } else if (result.data && result.data.error === '70015') {
              errorMessage = 'global.error.postBack.account.70015';
            }
            $translate(errorMessage).then(function(translatedValue) {
              var serverSideError = 'SS|' + translatedValue || dtmRule.defaultServerError;
              dtmService.setVar(dtmRule.eVar, serverSideError);
              dtmService.direct(dtmRule.errorRule);
            });
          } else {
            dtmService.direct(dtmRule.completeRule);
          }
          return result;
        })
        .catch(function(err) {
          var serverSideError = 'SS|' + dtmRule.defaultServerError;
          dtmService.setVar(dtmRule.eVar, serverSideError);
          dtmService.direct(dtmRule.errorRule);
          return $q.reject(err);
        });
    };

    service.processUserInfo = function(customerAccounts) {
      var userInfo = {
        uuid: $rootScope.userInfo.uuid,
        isAccountLinked: true
      };
      userInfo.firstName = customerAccounts.firstName;
      userInfo.lastName = customerAccounts.lastName;
      userInfo.accounts = customerAccounts.accounts;
      userInfo.profileType = customerAccounts.profileType;
      userService.login(userInfo);

      // Below logic updates "isAccountLinked" state is Angular 7 User Service
      downgradedUserService.setAccountLinked();

      //Update the serviceName
      if (($rootScope.userInfo.accounts || []).length > 0) {
        _.each($rootScope.userInfo.accounts, function(account) {
          if (account.serviceName === 'Internet') {
            account.serviceName = 'Internet/TV';
          }
        });
      }
    };

    return service;
  }
})();
